import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {CustomerService} from "../../../../service/api/customer.service";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {PagingDto} from "../../../../../../core/shared/dto/model/paging.dto";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {EntityStatusEnum} from "../../../../../../core/shared/entity/enum/entity-status.enum";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {DatesHelper} from "../../../../../../core/shared/helper/dates-helper";
import {QlQueryDto} from "../../../../../../core/shared/ql/data/dto/ql-query.dto";


@Component({
    selector: 'customer-statistics',
    templateUrl: 'customer-statistics.component.html',
    standalone: false
})
export class CustomerStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {


    newCustomers: number = 0;
    activeCustomers: number = 0;
    customerInteraction: number = 0;
    customerChurnRate: number = 0;

    customerTypeWidget: WidgetData;
    customerDistributionBrokerageWidget: WidgetData;
    customerDistributionByConsultationTypeWidget: WidgetData;
    customerListWithMostOpenTicketsWidget: WidgetData;
    customerGrowthByQuarterWidget: WidgetData;


    items: MenuItem[] | undefined;

    home: MenuItem | undefined;

    overviewDto: OverviewDto[];

    constructor(
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected customerService: CustomerService) {
        super(route, coreService)
    }

    ngOnInit(): void {


        this.items = [
            { label: 'Agent Module' },
        ];

        this.home = { icon: 'pi pi-home', routerLink: '/' };

        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.refreshCustomerTypeWidgets();
        this.refreshCustomerDistributionBrokerageWidgets();
        this.refreshCustomerDistributionConsultationTypeWidgets();
        this.refreshCustomerWithMostOpenTicketsWidgets();
        this.getCustomerOverviewThisMonth();
        this.getCustomerInteractionThisMonth();

        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/cr/config']);
    }

    refreshCustomerTypeWidgets() {
        this.customerTypeWidget = WidgetFactory.createWidget(
            'cr.customer.overview.customer.type.widget',
            'Customer Type',
            'history.chart',
            'list',
            'entity.groupBy',
            'cr.Customer',
            WidgetDataParam.create("fieldCategory", "customerType"),
            WidgetDataParam.create("fieldCategoryCount", "customerType_count"),
            WidgetDataParam.create("historyPeriodMode", "year"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );

        this.customerTypeWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["customerType", "createdDate"],
            [new ObjectRequestListAttribute("customerType", "Anzahl", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshCustomerDistributionBrokerageWidgets() {
        this.customerDistributionBrokerageWidget = WidgetFactory.createWidgetGroupBy(
            'cr.customer.overview.customer.distribution.brokerage.widget',
            'Customer Distribution By Brokerage Reason',
            'category',
            'entity.groupBy',
            'cr.Customer',
            'brokerPoaTypeReason',
            'brokerPoaTypeReason_count',
            this.filterCriteria,
            'brokerPoaTypeReason',
            'Anzahl');
    }

    refreshCustomerDistributionConsultationTypeWidgets() {
        this.customerDistributionByConsultationTypeWidget = WidgetFactory.createWidgetGroupBy(
            'cr.customer.overview.customer.distribution.consultation.type.widget',
            'Customer Distribution by Consultation Type',
            'category',
            'entity.groupBy',
            'cr.Customer',
            'customerConsultingType',
            'customerConsultingType_count',
            this.filterCriteria,
            'customerConsultingType',
            'Anzahl');
    }

    refreshCustomerWithMostOpenTicketsWidgets() {
        const alias = 'cr.customer.most.open.tickets';

        const qlQueryDto : QlQueryDto = {
            name : alias,
            type: 'view',
            fixedFilters : this.filterCriteriaForQuery,
            paging:PagingDto.create(0, 5),
            start : {
                name:'cr.Customer',
                as:'e',
                type:'entity',
                joins: [
                    {
                        joinType:'left',
                        type:'entity',
                        name:"+tmActiveTickets",
                        as:"tat"

                    }
                ]
            }

        }

        this.customerListWithMostOpenTicketsWidget = WidgetFactory.createWidgetListQl(
            alias,
            'Customer List with Most Open Tickets',
            'list',
            qlQueryDto
        );
    }

    getCustomerOverviewThisMonth() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            this.filterCriteria,
            [],
            ['entityStatus'],
            [new ObjectRequestListAttribute('entityStatus', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.customerService.groupBy(objectRequestList).subscribe(res => {

            this.newCustomers = res.entries.length;

            res.entries.forEach(item => {
                if (item['entityStatus'] === EntityStatusEnum.active) {
                    this.activeCustomers += item['entityStatus_count'];
                } else if (item['entityStatus'] === EntityStatusEnum.discarded || item['entityStatus'] == EntityStatusEnum.deleted || (item['entityStatus'] === EntityStatusEnum.obsolete)) {
                    this.customerChurnRate += item['entityStatus_count'];
                }
            });

            // Initialize overviewDto with default values
            this.overviewDto = [
                { label: 'New Customers', value: 0 },
                { label: 'Active Customers', value: 0 },
                { label: 'Customer Interactions', value: 0 },
                { label: 'Customer Churn Rate', value: 0 }
            ];


            for (let item of res.entries) {
                if (item['entityStatus'] === EntityStatusEnum.active) {
                    this.overviewDto.find(entry => entry.label === 'Active Customers').value += item['entityStatus_count'];
                } else if (
                    item['entityStatus'] === EntityStatusEnum.discarded ||
                    item['entityStatus'] === EntityStatusEnum.deleted ||
                    item['entityStatus'] === EntityStatusEnum.obsolete
                ) {
                    this.overviewDto.find(entry => entry.label === 'Customer Churn Rate').value += item['entityStatus_count'];
                }
            }

        });

    }

    getCustomerInteractionThisMonth() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [FilterCriteria.create('lastModifiedDate', FilterCriteria.cOperatorGreaterEqual, DatesHelper.calculateFirstDayOfCurrentMonth())],
            [],
            ['entityStatus'],
            [new ObjectRequestListAttribute('entityStatus', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.customerService.groupBy(objectRequestList).subscribe(res => {
            this.customerInteraction = res.entries.length;
        });

    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
